import { tv } from "../../variants/tv.js";
const sliderEmphasisVariants = {
    regular: '',
    medium: '',
    bold: ''
};
const sliderEmphases = Object.keys(sliderEmphasisVariants);
const emphasisVariants = {
    regular: {
        root: '',
        label: 'text-primary-13',
        valueText: 'text-primary-13',
        track: 'bg-primary-5',
        indicator: 'bg-primary-8',
        thumb: `
      bg-primary-1
      outline-primary-8
      focus:outline-primary-8
      focus:outline-offset-primary-1
      ring-primary-8
      data-disabled:bg-primary-6 data-disabled:ring-primary-5
    `
    },
    medium: {
        root: '',
        label: 'text-primary-13',
        valueText: 'text-primary-13',
        track: 'bg-primary-5',
        indicator: 'bg-primary-8',
        thumb: `
      bg-primary-1
      outline-primary-8
      focus:outline-primary-8
      focus:outline-offset-primary-1
      ring-primary-8
      data-disabled:bg-primary-6 data-disabled:ring-primary-5
    `
    },
    bold: {
        root: '',
        label: 'text-primary-1',
        valueText: 'text-primary-1',
        track: 'bg-primary-5/40',
        indicator: 'bg-primary-8',
        thumb: `
      bg-primary-1
      outline-primary-1
      focus:outline-primary-1
      focus:outline-offset-primary-1
      ring-primary-1
      data-disabled:bg-primary-6 data-disabled:ring-primary-5
   `
    }
};
const sliderVariants = tv({
    slots: {
        root: 'flex flex-col',
        label: 'flex text-body3',
        valueText: 'flex justify-between text-body2',
        control: 'flex w-full touch-none items-center p-3 select-none',
        track: 'h-2 w-full rounded-full hover:cursor-pointer hover:bg-primary-6 data-disabled:bg-primary-5 data-disabled:hover:cursor-not-allowed data-disabled:hover:bg-primary-5',
        indicator: 'rounded-full hover:cursor-pointer hover:bg-primary-9 data-disabled:bg-primary-5 data-disabled:hover:cursor-not-allowed data-disabled:hover:bg-primary-5',
        thumb: 'size-5 rounded-full shadow-sm ring-2 transition select-none hover:cursor-pointer hover:shadow-lg hover:transition-all hover:duration-300 focus:outline-2 focus:outline-offset-4 data-disabled:hover:cursor-not-allowed',
        marks: 'pointer-events-none absolute inset-0'
    },
    variants: {
        emphasis: emphasisVariants,
        hasHistogram: {
            true: {
                control: 'pt-0',
                track: 'rounded-t-none'
            }
        }
    },
    compoundVariants: [],
    defaultVariants: {
        emphasis: 'regular'
    }
});
export { emphasisVariants, sliderEmphases, sliderEmphasisVariants, sliderVariants };
